module.exports = __webpack_public_path__ + "static/media/translate-red.a9b76460.svg";